// frontend/packages/business-console/src/components/primitives/MetricBarCards.jsx
//
// The pipeline stat-card row used atop the list pages in the redesign (CRM,
// Quotes, Invoices, ...): a responsive row of compact metric cards, each with
// a colored bar under the number, and an optional final card on the brand
// gradient (the "value" tile in the mocks).
//
// Each card: { label, value, bar?, sub?, gradient? }
//   - bar: the accent color for the underline (ignored on the gradient card)
//   - gradient: render on the brand gradient (the highlight tile)
//   - sub: small caption under the value (used on the gradient tile)
//
// Presentational only; each page maps its own data to cards.

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useTokens } from './useTokens';
import Surface from './Surface';
import GradientHeroCard from './GradientHeroCard';

function Card({ card, t }) {
  if (card.gradient) {
    return (
      <GradientHeroCard radius="12px" sx={{ p: '11px 14px' }}>
        <Typography sx={{ fontSize: 11, fontWeight: 700, opacity: 0.85 }}>
          {card.label}
        </Typography>
        <Typography
          sx={{
            fontSize: 21,
            fontWeight: 900,
            letterSpacing: '-0.5px',
            mt: '3px',
          }}
        >
          {card.value}
        </Typography>
        {card.sub ? (
          <Typography
            sx={{ fontSize: 10.5, fontWeight: 600, opacity: 0.85, mt: '9px' }}
          >
            {card.sub}
          </Typography>
        ) : null}
      </GradientHeroCard>
    );
  }
  return (
    <Surface radius="12px" sx={{ p: '11px 14px' }}>
      <Typography sx={{ fontSize: 11, fontWeight: 700, color: t.muted }}>
        {card.label}
      </Typography>
      <Typography
        sx={{
          fontSize: 21,
          fontWeight: 900,
          letterSpacing: '-0.5px',
          mt: '3px',
          color: t.text,
        }}
      >
        {card.value}
      </Typography>
      <Box
        sx={{
          height: 3,
          borderRadius: 3,
          // `bar` may be a token key ('amber', 'green', ...) or a literal color.
          bgcolor: t[card.bar] || card.bar || t.blue,
          mt: '9px',
        }}
      />
    </Surface>
  );
}

export default function MetricBarCards({ cards = [], sx }) {
  const t = useTokens();
  if (!cards.length) return null;
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr 1fr',
          md: `repeat(${cards.length}, 1fr)`,
        },
        gap: 1.25,
        ...sx,
      }}
    >
      {cards.map((c) => (
        <Card key={c.label} card={c} t={t} />
      ))}
    </Box>
  );
}
